
import { useGetPurchasersQuery } from "../../store/api";
import { Box, Typography } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import { PurchasersTable } from "../puchasers/table";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";

export const PurchasersPage = () => {


  const selectedRaffle = useAppSelector(
    ({ selectedRaffle }: RootState) => selectedRaffle,
  );


  const { data: purchasers } = useGetPurchasersQuery(selectedRaffle.id, {
    skip: selectedRaffle.id === 'default',
  });


  const isMobileView = useIsMobileView();

  return (
    <Box paddingX={isMobileView ? 2 : 10} marginTop={2}>
      <Typography variant="h6" fontFamily={"Georgia"} paddingBottom={2} >
        Compradores
      </Typography>

      {purchasers && selectedRaffle.id !== 'default' ? <PurchasersTable raffleId={selectedRaffle.id} limit={selectedRaffle.limit} purchasers={purchasers} /> : null}
    </Box>
  );
};
